import { useMutation } from '@apollo/client';
import { graphql } from '@gql/gql';
import type { PersistHasADogMutation, PersistHasADogMutationVariables } from '@gql/graphql';
import { useCallback } from 'react';

export const PERSIST_HAS_A_DOG = graphql(`
  mutation PersistHasADog($data: PersistHasADogInput!) {
    persistHasADog(data: $data)
  }
`);

export const usePersistHasADog = () => {
  const [persist, { loading, error }] = useMutation<
    PersistHasADogMutation,
    PersistHasADogMutationVariables
  >(PERSIST_HAS_A_DOG, {
    onError: (err) => {
      console.log(err);
    },
  });

  const persistHasADog = useCallback(
    async (data: PersistHasADogMutationVariables['data']) => {
      await persist({
        variables: {
          data,
        },
      });
    },
    [persist],
  );

  return {
    persistHasADog,
    persistHasADogLoading: loading,
    persistHasADogError: error,
  };
};
